var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalCommunicationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50057 13.2135C13.0938 13.2135 15.9999 10.3074 15.9999 6.71419C15.9999 3.12098 13.0938 0.214844 9.50057 0.214844C5.90736 0.214844 3.00122 3.12098 3.00122 6.71419C3.00122 10.3074 5.90736 13.2135 9.50057 13.2135ZM9.50057 2.0718C12.0632 2.0718 14.143 4.15159 14.143 6.71419C14.143 9.27679 12.0632 11.3566 9.50057 11.3566C6.93797 11.3566 4.85818 9.27679 4.85818 6.71419C4.85818 4.15159 6.93797 2.0718 9.50057 2.0718Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64259 6.71633C8.15537 6.71633 8.57107 6.30064 8.57107 5.78785C8.57107 5.27507 8.15537 4.85938 7.64259 4.85938C7.12981 4.85938 6.71411 5.27507 6.71411 5.78785C6.71411 6.30064 7.12981 6.71633 7.64259 6.71633Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3555 6.71633C11.8683 6.71633 12.284 6.30064 12.284 5.78785C12.284 5.27507 11.8683 4.85938 11.3555 4.85938C10.8427 4.85938 10.427 5.27507 10.427 5.78785C10.427 6.30064 10.8427 6.71633 11.3555 6.71633Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50001 4.85696C10.0128 4.85696 10.4285 4.44126 10.4285 3.92848C10.4285 3.41569 10.0128 3 9.50001 3C8.98723 3 8.57153 3.41569 8.57153 3.92848C8.57153 4.44126 8.98723 4.85696 9.50001 4.85696Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.85669 15.9976H6.71365C7.73497 15.9976 8.5706 16.8332 8.5706 17.8545V18.783H10.4276V17.8545C10.4276 16.8332 11.2632 15.9976 12.2845 15.9976H14.1415V14.1406H4.85669V15.9976Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalCommunicationIcon);
export default __webpack_public_path__ + "static/media/totalCommunicationIcon.6286c68463ec7036ab4bfafbdd64c1fb.svg";
export { ForwardRef as ReactComponent };